<template>
  <div id="app" :class = "flag == 'PC'? '' : 'webapp'">
    <router-view/>
  </div>
</template>

<script>
import FLAG from './utils/index.js';
export default {
  name: 'App',
  data () {
    return {
      flag: FLAG
    }
  },
  created () {
    this.$store.dispatch('setStoreClientHeight', document.documentElement.clientHeight);
    if(FLAG == 'PHONE'){
      this.$store.dispatch('setStoreFlag', FLAG);
      this.setFontSize();
    } else {
      document.documentElement.style.fontSize = '12px'
      this.$store.dispatch('setStoreFlag', FLAG)
    }
    let lang = window.localStorage.getItem('lang');
    if(lang){
      this.$store.dispatch('setStoreLang', lang)
    }
  },
  mounted () {
    let timer = null
    window.addEventListener('resize', (e) => {
      if(timer){
        clearTimeout(timer)
      }
      timer = setTimeout( () => {
        this.$store.dispatch('setStoreClientHeight', document.documentElement.clientHeight);
      }, 500)
    })
  },
  methods: {
    setFontSize () {
      var documentElement = document.documentElement
      var width = documentElement.clientWidth// > 750 ? 750 : documentElement.clientWidth;
      // console.log(width)
      documentElement.style.fontSize = width / 7.5 + 'px'
      // console.log(documentElement.style.fontSize)
    }
  }
}
</script>

<style>
  @import '../static/font/font.css';
  @import './assets/reset.css';
  #app{
    overflow:hidden;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  }
  html,body{
    height: 100%;
  }
  #app.webapp{
    overflow-y: scroll;
    -webkit-overflow-scrolling : touch;
    height: 100%;
  }
/** 
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

*/
</style>



// WEBPACK FOOTER //
// src/App.vue